import { TooltipBubble } from '@carboncopyco/ui';
import { useEffect, useRef } from 'react';
import type { AnalyticsApiLog } from './types';

export function LogsTable({ logs }: { logs: AnalyticsApiLog[] }) {
  const parentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    parentRef.current?.lastElementChild?.scrollIntoView({
      behavior: 'smooth',
    });
  }, [logs]);

  return (
    <div className="flex flex-col w-full">
      <div className="pl-5 pt-3 font-bold w-full text-xs text-left uppercase text-gray-300 mt-4 h-10 dark:bg-gray-700 dark:text-gray-400">
        Logs
      </div>
      <div className="w-full overflow-y-auto h-[400px] text-sm text-left text-gray-500 dark:text-gray-400">
        <div
          ref={parentRef}
          className={
            'text-xs text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400 w-full'
          }
        >
          {logs
            .filter((log) => log.timestamp)
            .map((log) => (
              <div
                key={log.timestamp}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 overflow-hidden"
              >
                <TooltipBubble
                  placement="top-start"
                  title={
                    <div className="text-md p-4 w-[800px] bg-gray-50">
                      <div className="p-2">
                        <div className="font-bold">Timestamp:</div>
                        {log?.timestamp}
                      </div>
                      <div className="p-2">
                        <div className="font-bold">Message:</div> {log?.message}
                      </div>
                      <div className="p-2">
                        <div className="font-bold">Analytics session id:</div>{' '}
                        {log?.analyticsSessionId}
                      </div>
                      <div className="p-2">
                        <div className="font-bold">Data:</div>
                        {JSON.stringify(log.data) as string}
                      </div>
                    </div>
                  }
                >
                  <div className="w-full flex flex-col p-2">
                    <div className="text-xs text-gray-400">{log.timestamp}</div>
                    <div className="text-sm font-bold">{log.message}</div>
                    <div>{log?.data?.url as string}</div>
                  </div>
                </TooltipBubble>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
